<template>
  <v-container>
    <v-row  >
      <v-col cols="12" md="10" >
        <v-btn
          large
          text
          @click="$router.push({ name: 'empresa.contabilidad.contribuyentes' })"
          class="pl-1"
        >
          <v-icon>mdi-arrow-left</v-icon>
          <span class="ml-4 font-weight-medium" style="font-size: 15px">
             Volver a contribuyentes
          </span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row >
      <v-col cols="12" md="10">
        <div class="headline">Nuevo contribuyente</div>
        <v-card>
          <v-card-text>
    <SucursalesVSelect @handle-click="handleSelectSucursal" />


            <v-form
              class="crear-empresataxpayer"
              @submit.prevent="validateForm"
            >
             <v-text-field
                label="Nombre del contribuyente"
                v-model="nombre"
                required
                outlined
                hide-details="auto"
                v-validate="'required|max:100'"
                :error-messages="errors.collect('nombre')"
                data-vv-name="nombre"
              />
              <v-text-field
                label="CUIT"
                v-model="cuit"
                required
                outlined
                hide-details="auto"
                v-validate="'required|numeric|min:11|max:11'"
                :error-messages="errors.collect('cuit')"
                data-vv-name="cuit"
              />

              <v-text-field
                label="Razón Social"
                v-model="razonSocial"
                required
                outlined
                hide-details="auto"
                v-validate="'required|max:100'"
                :error-messages="errors.collect('razonSocial')"
                data-vv-name="razonSocial"
              />

              <v-file-input
                label="Certificado (.crt)"
                v-model="certFile"
                accept=".crt"
                required
                outlined
                show-size
                prepend-icon="mdi-certificate"
                v-validate="'required'"
                :error-messages="errors.collect('certFile')"
                data-vv-name="certFile"
              />

              <v-file-input
                label="Key Privada (.key)"
                v-model="keyFile"
                accept=".key"
                required
                outlined
                show-size
                prepend-icon="mdi-key"
                v-validate="'required|mimes:key'"
                :error-messages="errors.collect('keyFile')"
                data-vv-name="keyFile"
              />

              <v-switch
                v-model="isSandboxed"
                label="Pruebas (Sandbox)"
                inset
                class="mt-2"
              />

              <v-btn
                :loading="isLoading"
                :disabled="errors.any()"
                color="primary"
                class="mt-4"
                depressed
                type="submit"
                block
              >
                Guardar
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SucursalesVSelect from "@/components/sucursal/SucursalesVSelect.vue";

export default {
  name: "EmpresaContribuyentes",
  components: { SucursalesVSelect },

  $_veeValidate: {
    validator: "new",
  },

  data() {
    return {
      cuit: "",
      razonSocial: "",
      nombe: "",
      certFile: null,
      keyFile: null,
      isSandboxed: true, // por defecto en pruebas
      isLoading: false,
      sucursal_id: null,
    };
  },

  methods: {
    handleSelectSucursal(sucursal_id) {
      this.sucursal_id = sucursal_id;
      console.log("Sucursal seleccionada en crear contribuyente:", sucursal_id);
    },
    // validateForm() {
    //   this.$validator.validateAll().then(() => {
    //     if (!this.errors.any()) {
    //       this.$emit("process-persona", this.persona);
    //     } else {
    //       this.$validator.validate();
    //     }
    //   });
    // },
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.handleSubmit();
        } else {
          // Manejar errores de validación si es necesario
          this.$validator.validate();
        }
      });
    },
    async handleSubmit() {
      this.isLoading = true;
      const form = new FormData();
      form.append("cuit", this.cuit);
      form.append("nombre", this.nombre);
      form.append("razon_social", this.razonSocial);
      form.append("cert", this.certFile);
      form.append("key", this.keyFile);
      form.append("is_sandboxed", this.isSandboxed); // nuevo
      form.append("sucursal_id", this.sucursal_id); // nuevo

      try {
        await this.axios.post("/arca/empresa/taxpayer/crear/", form, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "success",
          text: "Contribuyente creado correctamente",
          icon: "mdi-check-circle-outline",
          timeout: 3000,
        });
        this.$router.push({ name: "empresa.contabilidad.contribuyentes" });
      } catch (err) {
        console.error(err);

        this.$updateBus.$emit("showSnackBar", {
          show: true,
          button: false,
          color: "error",
          text: "Error al crear contribuyente",
          icon: "mdi-alert-circle",
          timeout: 4000,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.crear-empresataxpayer {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 450px;
}
</style>
